/** @format */

import { UIText } from '@/components/ui/Text';
import { GTMheader } from '@/ducks/googleTagManager/helpers/google-tag-manager';
import { useAppTranslation } from '@/i18n/declarations';
import theme from '@/theme/styled-theme';
import { Link } from 'gatsby-plugin-intl';
import React, { FunctionComponent as FC, memo, useMemo } from 'react';
import styled from 'styled-components';

export const RenderPagesExt: FC<RenderPagesProps> = ({ mobile = false }) => {
  const { intl } = useAppTranslation();

  const setGTMhelpCenter = () => GTMheader('help_center');

  const activeLinkColor = theme.colors.joivy.yellow;

  const PAGES = useMemo(
    () => [
      {
        label: 'menu_help_center',
        href: `/${intl.locale}/help-center/`,
        external: true,
        onClick: setGTMhelpCenter,
      },
    ],
    [setGTMhelpCenter],
  );

  if (mobile)
    return (
      <>
        {PAGES.map(page => (
          <MenuItem key={page.href}>
            {page.external && (
              <a href={page.href} target="_blank" onClick={page.onClick}>
                <PageChild label={page.label} />
              </a>
            )}
            {!page.external && (
              <Link to={page.href} onClick={page.onClick} activeStyle={{ color: activeLinkColor }}>
                <PageChild label={page.label} />
              </Link>
            )}
          </MenuItem>
        ))}
      </>
    );

  return (
    <>
      {PAGES.map(page => (
        <li key={page.href}>
          {page.external && (
            <a href={page.href} target="_blank" onClick={page.onClick}>
              <PageChild label={page.label} />
            </a>
          )}
          {!page.external && (
            <Link to={page.href} onClick={page.onClick}>
              <PageChild label={page.label} />
            </Link>
          )}
        </li>
      ))}
    </>
  );
};

const PageChild: FC<{ label: string }> = memo(({ label }) => <UIText text={label} intlFormatter />);

interface RenderPagesProps {
  mobile?: boolean;
}

const MenuItem = styled.li`
  font-family: ${({ theme }) => theme.font.title};
  font-size: clamp(1.75rem, 1.0657rem + 2.9197vw, 2.5rem);
  margin-bottom: clamp(1.5rem, 1.0438rem + 1.9465vw, 2rem);

  &:last-child {
    margin-bottom: clamp(2rem, 1.0876rem + 3.8929vw, 3rem);
  }
`;
